<script setup>
import { computed } from "vue";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

const props = defineProps({
  quality: {
    type: String,
    required: true
  }
});

const styles = computed(() => ({
  "product-quality": true,
  [`product-quality--${props.quality}`]: true
}));

const icon = computed(() => {
  if (props.quality === "good") {
    return "thumbs-up";
  }
  if (props.quality === "premium") {
    return "premium";
  }
  return null;
});
</script>

<template>
  <div :class="styles">
    <UseSvg v-if="icon" :icon="icon" type="print" class="product-quality__icon" />
    <span class="product-quality__text">{{ quality }}</span> &nbsp;quality
  </div>
</template>

<style lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";

.product-quality {
  font-size: 12px;
  font-weight: 500;
  color: $pod-gray-modern-900;
  border-radius: 4px;
  padding: 2px 6px;
  text-align: center;
  display: flex;
  align-items: center;

  &--basic {
    background: $pod-gray-modern-200;
  }

  &--good {
    background: $pod-gray-modern-500;
    color: $white;
  }

  &--premium {
    background: $pod-gray-modern-900;
    color: $white;
  }

  &__icon {
    width: 14px;
    height: 14px;
    margin-right: 2px;
  }

  &__text {
    text-transform: capitalize;
  }
}
</style>
